import { Component, OnInit, OnDestroy } from '@angular/core';
import { LibraryAsset } from '../models/library-asset';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'dac-exercise-list',
  templateUrl: './exercise-list.component.html',
  styleUrls: ['./exercise-list.component.scss']
})
export class ExerciseListComponent implements OnInit,OnDestroy {

  public title:string;
  public assetType:string;
  private subscription;

  constructor(private router:Router, private route:ActivatedRoute) { }
  
  ngOnDestroy(): void {
   this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.subscription = this.route.params.subscribe(params => {
      let assetType = params['type'];
      if (assetType == 'articles') {
        this.assetType = 'article';
        this.title = "Article";
      }
      else {
        this.assetType = 'assignment';
        this.title = "Exercise";
      }
    });
  }

  viewAsset(asset:LibraryAsset) {
    this.router.navigate([asset.id], {relativeTo: this.route});
  }

}



// WEBPACK FOOTER //
// ./src/app/library-assets/exercise-list/exercise-list.component.ts